// extracted by mini-css-extract-plugin
module.exports = {"s1g43no":"s1g43no"};